import { render, staticRenderFns } from "./process_route_edit.vue?vue&type=template&id=dd3fa476&scoped=true"
import script from "./process_route_edit.vue?vue&type=script&lang=js"
export * from "./process_route_edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd3fa476",
  null
  
)

export default component.exports